import React from 'react'

function OpticalInfo() {
  return (
    <div>OpticalInfo</div>
  )
}

export default OpticalInfo